import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    messages: [],
    processing: 0,
    districts: [],
    location: [],
    nationality: [],
    mobile: null,
    dob: null,
    yob:null,
    id: null,
    time: null,
    email: null,
    gender: null,
    sexual_orientation: null,
    name: null,
    centers: null,
    selectedServices: null,
    date: null,
    actionName: "",
    selectedDistrict: null,
    selectedCenter: null,
    selectedNationality: null,
    selectedLocation: null,
    createPatient: false
  },
  mutations: {
    initialiseStore(state) {
      // Check if the ID exists
      if (localStorage.getItem("store")) {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem("store")))
        );
      }
    },
    SET_MESSAGES: (state, _messages) => {
      console.log(JSON.stringify(_messages));
      state.messages = _messages;
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile;
    },
    SET_CREATE_PATIENT: (state, _value) => {
      state.createPatient = _value;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_ID: (state, id) => {
      state.id = id;
    },
    SET_GENDER: (state, gender) => {
      state.gender = gender;
    },
    SET_SEXUAL_ORIENTATION: (state, sexual_orientation) => {
      state.sexual_orientation = sexual_orientation;
    },
    SET_DOB: (state, dob) => {
      state.dob = dob;
    },
      SET_YOB: (state, yob) => {
          state.yob = yob;
      },
    SET_INFO: (state, info) => {
      state.info = info;
      localStorage.setItem("info", JSON.stringify(info));
    },
    SET_EMAIL: (state, email) => {
      state.email = email;
    },
    SET_NATIONALITY: (state, nationality) => {
      state.nationality = nationality;
    },
    SET_DATE: (state, date) => {
      state.date = date;
    },
    SET_TIME: (state, time) => {
      state.time = time;
    },
    SET_ACTION: (state, _value) => {
      state.actionName = _value;
    },
    START_PROCESSING: state => {
      state.processing++;
    },
    STOP_PROCESSING: state => {
      if (state.processing > 0) {
        state.processing--;
      }
    },
    SET_DISTRICTS_LIST: (state, districts) => {
      state.districts = districts;
    },
    SET_SELECTED_CENTER: (state, _value) => {
      state.selectedCenter = _value;
    },
    SET_SELECTED_DISTRICT: (state, _value) => {
      state.selectedDistrict = _value;
    },
    SET_SELECTED_LOCATION: (state, location) => {
      state.selectedLocation = location;
    },

    SET_SELECTED_SERVICES: (state, services) => {
      state.selectedServices = services;
    }
  },
  actions: {
    START_PROCESSING: ({ commit }) => {
      commit("START_PROCESSING");
    },
    STOP_PROCESSING: ({ commit }) => {
      commit("STOP_PROCESSING");
    },
    GET_MESSAGES: ({ commit }, messages) => {
      console.log("SET MESSAGES TO " + JSON.stringify(messages));
      commit("SET_MESSAGES", messages);
    },
    SET_MOBILE: ({ commit }, _value) => {
      commit("SET_MOBILE", _value);
    },
    SET_CREATE_PATIENT: ({ commit }, _value) => {
      commit("SET_CREATE_PATIENT", _value);
    },
    SET_NAME: ({ commit }, _value) => {
      commit("SET_NAME", _value);
    },
    SET_NATIONALITY: ({ commit }, _value) => {
      commit("SET_NATIONALITY", _value);
    },
    SET_EMAIL: ({ commit }, _value) => {
      commit("SET_EMAIL", _value);
    },
    SET_GENDER: ({ commit }, _value) => {
      commit("SET_GENDER", _value);
    },
    SET_SEXUAL_ORIENTATION: ({ commit }, _value) => {
      commit("SET_SEXUAL_ORIENTATION", _value);
    },
    SET_ID: ({ commit }, _value) => {
      commit("SET_ID", _value);
    },
    SET_DOB: ({ commit }, _value) => {
      commit("SET_DOB", _value);
    },
      SET_YOB: ({ commit }, _value) => {
          commit("SET_YOB", _value);
      },
    SET_ACTION: ({ commit }, _value) => {
      commit("SET_ACTION", _value);
    },
    SET_DATE: ({ commit }, _value) => {
      commit("SET_DATE", _value);
    },
    SET_TIME: ({ commit }, _value) => {
      commit("SET_TIME", _value);
    },

    SET_INFO: ({ commit }, _value) => {
      commit("SET_INFO", _value);
    },
    SET_SELECTED_SERVICES: ({ commit }, _value) => {
      commit("SET_SELECTED_SERVICES", _value);
    },
    SET_SELECTED_CENTER: ({ commit }, _value) => {
      commit("SET_SELECTED_CENTER", _value);
    },
    SET_SELECTED_DISTRICT: ({ commit }, _value) => {
      commit("SET_SELECTED_DISTRICT", _value);
    },

    SET_SELECTED_LOCATION: ({ commit }, _value) => {
      commit("SET_SELECTED_LOCATION", _value);
    }
  },
  modules: {},
  getters: {
    getdistricts: state => state.districts,
    getlocation: state => state.location,
    getnationality: state => state.nationality,
    centers: state => state.centers,
    getdate: state => state.date,
    getname: state => state.name,
    getservice: state => state.selectedServices,
    getidnumber: state => state.id,
    getgender: state => state.gender,
    getselectorientation: state => state.sexual_orientation,
    getDateofbirth: state => state.dob,
      getYearofbirth: state => state.yob,
    getemail: state => state.email,
    getmobile: state => state.mobile,
   year_of_birth: () => {
      const _arrYears = [];

      const today = moment(); /*.format("YYYY-MM-DD")*/

      console.log("Today: " + today);

      const end_year = today.year();

      console.log("This Year: " + end_year);

      const new_end_year = moment(today.subtract(18, "years"));

      console.log("Year - 18: " + new_end_year.year());

      const start_year = moment(today.subtract(100, "years"));

      console.log("Year - 100: " + start_year.year());


      for (let i = new_end_year.year(); i >= start_year.year(); i--) {
        //console.log("Year: "+i);
        _arrYears.push({ name: i, key: i });
      }

      return _arrYears;
    },
    month_of_birth: () => {
      const _arrMonth = [];

      const today = moment(); /*.format("YYYY-MM-DD")*/

      console.log("Today: " + today);

      const end_month = today.month();

      console.log("This month: " + end_month);
      

      const start_month = moment(today.subtract(0, "month"));

      console.log("month - 0: " + start_month.month());


      return _arrMonth;
    }
  }
});
